export default "__VITE_ASSET__DhmNgbIm__"